import IClosePanelAction from "chrome/panel/duck/actions/interfaces/IClosePanelAction";
import PanelActionType from "chrome/panel/duck/actionTypes/panelActionType";

export default function closePanel(): IClosePanelAction {
    return {
        type: PanelActionType.CLOSE_PANEL,
    };
}